import React from "react";

const Footer = () => {
  return (
    <div className="flex justify-center w-full bg-gray-200 px-10 py-5 mt-10">
      <div className="font-thin text-xs text-center font-montserrat">
        &copy; 2020 Firhan Ramadhan. All Rights Reserved | Designed By Firhan
        Ramadhan
      </div>
    </div>
  );
};

export default Footer;
